function RegularSelectionsMarketGroup()
{
    this.GroupKey = null;
    this.Selections = [];
}

window.RegularSelectionsMarketGroup = RegularSelectionsMarketGroup;